<template>
  <div class="verify-mobile-component">
    <div class="mobile-block">
      <ym-field class="ym-field"
                :class="{ 'active': mobile !== '' }"
                v-model.trim="mobile"
                type="tel"
                placeholder="输入手机号码"
                :attr="{ autocomplete: false }"
                @keyup.enter.prevent="handleSubmit"
      />
    </div>
    <div class="sms-block"
         :class="{ 'active': smsCode !== '' }"
    >
      <div class="sms-input">
        <ym-field class="ym-field"
                  :class="{ 'active': smsCode !== '' }"
                  v-model.trim="smsCode"
                  placeholder="输入验证码"
                  maxlength="6"
                  :attr="{ autocomplete: false }"
                  @keyup.enter.prevent="handleSubmit"
                  @focusout.native="handleSubmit"
        />
      </div>
      <div class="sms-btn"
           slot="button"
      >
        <ym-button class="submit-btn"
                   id="geetest-verify-sms-btn"
                   size="medium"
                   type="primary"
                   round
                   :disabled="smsCodeDisabled"
                   v-ym-report:MILLION_EXVIP_GET_CODE_CLICK=""
        >
          {{ smsCodeText }}
        </ym-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { Field, Button } from '@ymba/ym-ui';
  import geetestMixin from '@/mixins/geetest';
  import validator from '@/utils/validator';

  export default {
    name: 'VerifyMobile',
    mixins: [geetestMixin],
    components: {
      'ym-field': Field,
      'ym-button': Button,
    },
    data() {
      return {
        mobile: '',
        smsCode: '',
        smsType: 'verify',
      };
    },
    watch: {
      duration(val) {
        if (val > 0) {
          this.smsCodeDisabled = true;
        }
      },
      smsCode(val) {
        if (!validator.isMobile(this.mobile)) {
          this.smsCodeDisabled = true;
          return;
        }
        if (val.length >= 6) {
          const params = {
            phone: this.mobile,
            smsCode: val,
          };
          this.$emit('submit-action', params);
        }
      },
    },
    methods: {
      async handleSubmit() {
        if (!validator.isEmpty(this.mobile) && !validator.isMobile(this.mobile)) {
          this.$toast('请填写正确的手机号');
        }
        if (validator.isEmpty(this.smsCode)) {
          this.$toast('请填写验证码');
        }
        const params = {
          mobile: this.mobile,
          smsCode: this.smsCode,
        };
        this.$emit('submit-action', params);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .verify-mobile-component {
    margin-bottom: 88px;
  }

  .mobile-block {
    height: 88px;
    margin-bottom: @size-small;
    border-radius: 10px;
    .ym-field {
      height: 88px;
      border-radius: 10px;
      /deep/ input {
        padding-top: 0;
        padding-bottom: 0;
      }
      &.active {
        box-sizing: border-box;
        background: @color-white;
        border: @border-width-base @border-style-base @color-gray-light;
      }
    }
  }

  .sms-block {
    position: relative;
    box-sizing: border-box;
    padding-right: 14px;
    display: flex;
    align-items: center;
    width: 470px;
    height: 88px;
    background: @color-white;
    border-radius: 10px;
  }

  .sms-input {
    .ym-field {
      /deep/ input {
        padding-top: 0;
        padding-bottom: 0;
      }
      background: @color-white;
      &.active {
        background: @color-white;
      }
    }
  }

  .sms-btn {
    width: 160px;
    height: 58px;
    border-radius: 10px;
    /deep/ button {
      width: 160px;
      height: 58px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: @font-size-small;
      line-height: 1.1;
      background: #ff4d3e;
      border-radius: 10px;
      border: none;
    }
  }
</style>
